import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBolt, FaYoutube, FaInstagram, FaFacebook } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

const Navbar = ({ selectedPlatform, onSelectPlatform }) => {
  const [siteTitle, setSiteTitle] = useState('VidDownloader Pro');

  // Load site title from localStorage
  useEffect(() => {
    const loadTitle = () => {
      const storedTitle = localStorage.getItem('navbar_title');
      if (storedTitle) {
        setSiteTitle(storedTitle);
      } else {
        setSiteTitle('VidDownloader Pro');
      }
    };

    // Load on mount
    loadTitle();

    // Listen for storage changes (cross-tab)
    window.addEventListener('storage', loadTitle);

    // Poll for changes (same-tab updates)
    const interval = setInterval(loadTitle, 500);

    return () => {
      window.removeEventListener('storage', loadTitle);
      clearInterval(interval);
    };
  }, []);
  const handlePlatformClick = (platformId, e) => {
    e.preventDefault();
    onSelectPlatform(platformId);
    // Smooth scroll to platform cards section
    const platformSection = document.getElementById('platform-section');
    if (platformSection) {
      platformSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToFAQ = (e) => {
    e.preventDefault();
    const faqSection = document.getElementById('faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="website-navbar sticky top-0 z-50 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <motion.div 
            className="logo-button flex items-center gap-2 cursor-pointer"
            whileHover={{ scale: 1.05 }}
            onClick={scrollToTop}
          >
            <div 
              className="w-8 h-8 rounded-lg flex items-center justify-center"
              style={{ background: `linear-gradient(135deg, var(--primary-color), var(--secondary-color))` }}
            >
              <FaBolt style={{ color: 'var(--text-color)' }} size={18} />
            </div>
            <span className="font-bold text-xl" style={{ color: 'var(--text-color)' }}>{siteTitle}</span>
          </motion.div>

          <div className="hidden md:flex items-center gap-8">
            <motion.button 
              onClick={scrollToTop}
              className="nav-button transition-all duration-300 hover:opacity-80"
              style={{ color: 'var(--text-color)' }}
              whileHover={{ scale: 1.05 }}
            >
              Home
            </motion.button>
            <motion.button 
              onClick={(e) => handlePlatformClick('youtube', e)}
              className="nav-button transition-all duration-300 flex items-center gap-2 hover:opacity-80"
              style={{ 
                color: selectedPlatform === 'youtube' ? 'var(--accent-color)' : 'var(--text-color)' 
              }}
              whileHover={{ scale: 1.05 }}
            >
              <FaYoutube className="text-red-500" />
              YouTube
            </motion.button>
            <motion.button 
              onClick={(e) => handlePlatformClick('instagram', e)}
              className="nav-button transition-all duration-300 flex items-center gap-2 hover:opacity-80"
              style={{ 
                color: selectedPlatform === 'instagram' ? 'var(--accent-color)' : 'var(--text-color)' 
              }}
              whileHover={{ scale: 1.05 }}
            >
              <FaInstagram className="text-pink-500" />
              Instagram
            </motion.button>
            <motion.button 
              onClick={(e) => handlePlatformClick('facebook', e)}
              className="nav-button transition-all duration-300 flex items-center gap-2 hover:opacity-80"
              style={{ 
                color: selectedPlatform === 'facebook' ? 'var(--accent-color)' : 'var(--text-color)' 
              }}
              whileHover={{ scale: 1.05 }}
            >
              <FaFacebook className="text-blue-500" />
              Facebook
            </motion.button>
            <motion.button 
              onClick={(e) => handlePlatformClick('tiktok', e)}
              className="nav-button transition-all duration-300 flex items-center gap-2 hover:opacity-80"
              style={{ 
                color: selectedPlatform === 'tiktok' ? 'var(--accent-color)' : 'var(--text-color)' 
              }}
              whileHover={{ scale: 1.05 }}
            >
              <SiTiktok className="text-gray-300" />
              TikTok
            </motion.button>
          </div>

          <motion.button
            onClick={scrollToFAQ}
            className="faq-button px-4 py-2 border rounded-lg transition-all duration-300 hover:opacity-80"
            style={{ 
              color: 'var(--text-color)', 
              borderColor: 'var(--accent-color)',
              backgroundColor: 'transparent'
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            FAQ & Help
          </motion.button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
